import React, { useState } from 'react';

import { ControlLabel } from 'react-bootstrap';

import ActivityFormFieldWrapper from '../ActivityForm/ActivityFormFieldWrapper';
import Modal from '../../utils/ModalComponet';
import { ActivitySource, ActivitySourceValue } from '../../../types/Activity';
import SimpleSelect from '../../utils/FormWidgets/SimpleSelect';

type Props = {
  display: string;
  initialValue: ActivitySourceValue | undefined;
  label: string;
  onMetaFieldsChange(value: ActivitySource): void;
  existingSource?: ActivitySourceValue;
};

enum SourceLabel {
  BACH = 'BACH',
  BACH2 = 'BACH2',
  FAREHARBOR = 'Fareharbor',
  REDEAM = 'Redeam',
  Peek = 'Peek',
  Singenuity = 'Singenuity',
}

export const defaultSourceOptions = [
  { id: 1, label: SourceLabel.BACH, value: ActivitySource.bach },
  { id: 2, label: SourceLabel.BACH2, value: ActivitySource.bach2 },
  { id: 3, label: SourceLabel.FAREHARBOR, value: ActivitySource.fareharbor },
  { id: 4, label: SourceLabel.REDEAM, value: ActivitySource.redeam },
  { id: 5, label: SourceLabel.Peek, value: ActivitySource.peek },
  { id: 6, label: SourceLabel.Singenuity, value: ActivitySource.singenuity },
];

const ActivitySourceOptions = ({
  display,
  initialValue,
  label,
  existingSource,
  onMetaFieldsChange,
}: Props) => {
  const [source, setSource] = useState<ActivitySourceValue | undefined>(
    initialValue
  );

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const closeModal = () => {
    setSource(initialValue);
    setIsOpen(false);
  };

  const modalAction = () => {
    setIsOpen(false);
    setSource(source);
    onMetaFieldsChange(source as ActivitySource);
  };

  return (
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    <ActivityFormFieldWrapper label={label} display={display}>
      <Modal
        open={isOpen}
        closeModal={closeModal}
        cancel={closeModal}
        action={modalAction}
        actionButtonText='OK'
      >
        <div style={{ marginBottom: '40px' }}>
          STOP! Are you sure you want to change the source of this experience?
          This will impact/can break the booking flow and payment flows for this
          experience.
        </div>
      </Modal>
      <ControlLabel>{label}:</ControlLabel>
      <div style={{ flex: 1 }}>
        <SimpleSelect
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          onChange={(value: ActivitySourceValue) => {
            setSource(value);
            setIsOpen(true);
          }}
          disabled={!!existingSource}
          value={source}
          data={defaultSourceOptions}
        />
      </div>
    </ActivityFormFieldWrapper>
  );
};

export default ActivitySourceOptions;
